import { __decorate } from "tslib";
import { WORKSPACE_SERVICE_URI } from '@workspace/shared/constants/envConfig';
import { PsHttpService } from '@patsnap/tahiti-core';
import { injectable } from 'inversify';
let CustomFieldApiImpl = class CustomFieldApiImpl extends PsHttpService {
    get options() {
        return {
            baseURL: `${WORKSPACE_SERVICE_URI}/workspace/web`,
            headers: {
                'X-API-Version': '2.0',
            },
        };
    }
    async removeCustomField(data) {
        const res = await this.delete({
            url: 'field',
            data,
        });
        return res.data;
    }
    async copyCustomField(data) {
        const res = await this.post({
            url: 'field/share',
            data,
        });
        return res.data;
    }
    async copyCustomFieldAsPublic(data) {
        const res = await this.post({
            url: 'field/to-public',
            data,
        });
        return res.data;
    }
    async queryFields(params) {
        const res = await this.get({
            url: 'field',
            params,
        });
        return res.data;
    }
};
CustomFieldApiImpl = __decorate([
    injectable()
], CustomFieldApiImpl);
export { CustomFieldApiImpl };
